export enum AlertPlacementEnum {
    Default = 'default',
    Modal = 'modal',
}
